// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__2ed-r","light_bar":"loading_light_bar__Avcp6","dark_bar":"loading_dark_bar__RHnP8"};